const OTROS = '0'
const DNI = '1'
const CARNET_DE_EXTRANJERIA = '4'
const RUC = '6'
const PASAPORTE = '7'
const CED_DIPLOMATICA = 'A'

const __dictionary = {
  [OTROS]: {
    id: OTROS,
    nombre: 'DOC.TRIB.NO.DOM.SIN.RUC',
    nombreCorto: 'OTROS'
  },
  [DNI]: {
    id: DNI,
    nombre: 'DOC. NACIONAL DE IDENTIDAD',
    nombreCorto: 'DNI'
  },
  [CARNET_DE_EXTRANJERIA]: {
    id: CARNET_DE_EXTRANJERIA,
    nombre: 'CARNET DE EXTRANJERIA',
    nombreCorto: 'CARNET EXTRANJ'
  },
  [RUC]: {
    id: RUC,
    nombre: 'REG. UNICO DE CONTRIBUYENTES',
    nombreCorto: 'RUC'
  },
  [PASAPORTE]: {
    id: PASAPORTE,
    nombre: 'PASAPORTE',
    nombreCorto: 'PASAPORTE'
  },
  [CED_DIPLOMATICA]: {
    id: CED_DIPLOMATICA,
    nombre: 'CED. DIPLOMATICA DE IDENTIDAD',
    nombreCorto: 'CED DIPLOMATICA'
  }
}

const __array = [
  __dictionary[OTROS],
  __dictionary[DNI],
  __dictionary[CARNET_DE_EXTRANJERIA],
  __dictionary[RUC],
  __dictionary[PASAPORTE],
  __dictionary[CED_DIPLOMATICA]
]

export default Object.freeze({
  OTROS,
  DNI,
  CARNET_DE_EXTRANJERIA,
  RUC,
  PASAPORTE,
  CED_DIPLOMATICA,
  __dictionary,
  __array
})
